var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchCategoryMigrationTransfer32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture-Category/32/Migration-Transfer_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#055F4E",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56C0A7",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture-Category/32/Migration-Transfer_32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-1)",
    x: 4,
    y: 4,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    id: "#879196-Border-Copy-17",
    stroke: "#879196",
    strokeWidth: 2,
    x: 1,
    y: 1,
    width: 46,
    height: 46
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Category/32/Migration-Transfer_32",
    transform: "translate(8.000000, 8.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.398,22.763 L15.5,16.022 L9.601,22.763 L13.5,22.763 C13.776,22.763 14,22.987 14,23.263 L14,28.763 L17,28.763 L17,23.263 C17,22.987 17.223,22.763 17.5,22.763 L21.398,22.763 Z M22.876,22.934 C23.005,23.081 23.036,23.291 22.955,23.47 C22.874,23.648 22.696,23.763 22.5,23.763 L18,23.763 L18,29.263 C18,29.539 17.776,29.763 17.5,29.763 L13.5,29.763 C13.223,29.763 13,29.539 13,29.263 L13,23.763 L8.5,23.763 C8.303,23.763 8.126,23.648 8.044,23.47 C7.963,23.291 7.994,23.081 8.124,22.934 L15.124,14.934 C15.313,14.716 15.686,14.716 15.876,14.934 L22.876,22.934 Z M30,15.289 C30,18.615 28.13,20.763 25.237,20.763 L23,20.763 L23,19.763 L25.237,19.763 C28.011,19.763 29,17.452 29,15.289 C29,13.47 27.825,11.526 24.526,11.526 C24.372,11.526 24.226,11.455 24.131,11.334 C24.037,11.213 24.003,11.054 24.041,10.905 C24.337,9.72 24.092,8.629 23.369,7.911 C22.652,7.201 21.571,6.967 20.406,7.268 C20.278,7.303 20.141,7.283 20.026,7.215 C19.912,7.147 19.829,7.036 19.796,6.908 C18.974,3.678 16.119,3 13.868,3 C13.628,3.001 7.973,3.112 7.973,10.316 C7.973,10.592 7.75,10.816 7.473,10.816 C3.071,10.816 3.001,14.922 3,15.096 C3,17.626 5.048,19.763 7.473,19.763 L8,19.763 L8,20.763 L7.473,20.763 C4.506,20.763 2,18.168 2,15.096 C2,15.044 2.058,10.138 6.981,9.831 C7.245,2.092 13.8,2 13.868,2 C17.358,2 19.741,3.487 20.631,6.2 C21.965,5.986 23.202,6.338 24.073,7.201 C24.923,8.045 25.294,9.241 25.126,10.546 C28.709,10.788 30,13.204 30,15.289 L30,15.289 Z",
    id: "Migration-Transfer_Category-Icon_32_Squid"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchCategoryMigrationTransfer32);
export default __webpack_public_path__ + "static/media/Arch-Category_Migration-Transfer_32.6937d333118106c5ff31c40ce99f8b8d.svg";
export { ForwardRef as ReactComponent };